import { createAsyncThunk } from '@reduxjs/toolkit'
import { FetchTeamMemberTaskParams, TeamMemberTask } from './types'
import axios from '../../../config/axios'
import { AxiosError } from 'axios'

export const fetchTeamMemberTask = createAsyncThunk<TeamMemberTask, FetchTeamMemberTaskParams>(
  'teamMemberTasks/fetchTeamMemberTask',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get<TeamMemberTask>('/tasks/teamMemberTask', {
        params: {
          teamMemberWorkdayId: params.teamMemberWorkdayId,
          teamMemberEmail: params.teamMemberEmail,
        },
      })
      console.log('redux/task/teamMemberTasks/actions:', response.data)
      return response.data
    } catch (error) {
      if (error instanceof AxiosError && error.response) {
        return rejectWithValue(error.response.data)
      }
      return rejectWithValue('An unexpected error occurred')
    }
  },
)
